import {
    archiveSurveyWithId, GetCopyOfTextWithInstanceLang,
    GetSurveys, GetUseCases, GetUser,
    GetUserBySurvey,
    PostSurveyWithId,
    PostUsersToAnnieUserSurvey, updateSurvey,
    UpdateSurveyWithId, useUpdateSurveyWithId
} from "../api/APISurvey"
import "../scss/Surveys.scss"
import {FormattedMessage, useIntl} from "react-intl"
import {formatDate, updateTimeToServerFormat} from "../Formats"
import {Popover, Popup, Skeleton, StatusText} from "../UIElements"
import { ReactComponent as Loader } from "../svg/loader.svg"
import { ReactComponent as PlusIcon } from "../svg/plus.svg"
import {ReactComponent as OptionsIcon} from "../svg/options.svg";
import {Link} from "react-router-dom";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {ReactComponent as DuplicateIcon} from "../svg/duplicate.svg";
import {ReactComponent as SortOrderIcon} from "../svg/order.svg";
import {ReactComponent as ArchiveIcon} from "../svg/archive.svg";
import {ReactComponent as DeleteIcon} from "../svg/delete-s.svg";
import {ReactComponent as Chevron} from "../svg/chevron.svg";
import { ReactComponent as ContactsIcon } from "../svg/contact.svg"
import { ReactComponent as UnlinkIcon } from "../svg/unlink.svg"
import {queryClient, useAuthData, useCurrentUserData, useLanguageData} from "../App";
import _ from "lodash"
import {useSnackbar} from "../Content";
import {ReactComponent as LoadingIcon} from "../svg/loading.svg";
import {removeUnnecessaryKeys} from "../DataFunctions";

export default function Surveys() {
    const showStatusFromStorage = localStorage.getItem("showStatus")
    const [showStatus, setShowStatus] = useState(showStatusFromStorage ? showStatusFromStorage : "all")
    let showStatusForAPI
    switch (showStatus) {
        case "scheduled":
            showStatusForAPI = "SCHEDULED"
            break
        case "finished":
            showStatusForAPI = "FINISHED"
            break
        case "inProgress":
            showStatusForAPI = "IN PROGRESS"
            break
        case "archived":
            showStatusForAPI = "ARCHIVED"
            break
        case "draft":
            showStatusForAPI = "DRAFT"
            break
        default:
            showStatusForAPI = null
    }

    const {instanceLang} = useLanguageData()
    const { status, data, error, isFetching, refetch } = GetSurveys(showStatusForAPI)
    const getUseCases = GetUseCases()
    const getCopyOfSurveyText = GetCopyOfTextWithInstanceLang(instanceLang)

    useEffect(()=>{
        refetch()
    },[showStatusForAPI])

    useEffect(()=>{
        document.title = intl.formatMessage({
                id:"main.sidebar.surveys",
                defaultMessage:"Surveys",
            }) + " | Annie Admin"
    },[])

    const intl = useIntl()
    const sortMethodFromStorage = localStorage.getItem("sortMethod")
    const sortDirectionFromStorage = localStorage.getItem("sortDirection")
    const groupingSpanFromStorage = localStorage.getItem("groupingSpan")
    const [sortMethod, setSortMethod] = useState(sortMethodFromStorage ? sortMethodFromStorage === "alphabetical" ? "updated" : sortMethodFromStorage : "updated")
    const [sortDirection, setSortDirection] = useState(sortDirectionFromStorage ? JSON.parse(sortDirectionFromStorage) : true)
    const [searchText, setSearchText] = useState("")
    const [groupingSpan, setGroupingSpan] = useState(groupingSpanFromStorage ? groupingSpanFromStorage : "month")
    let searchData, searchGroups, sortedCombinedGroups

    function groupAndSortSurveys(surveys, groupingCriteria, sortMethod, sortDirection) {
        function getGroupKey(survey) {
            const date = survey //new Date(survey);

            let year = date.getFullYear();
            let month = ('0' + (date.getMonth() + 1)).slice(-2);
            let day = ('0' + date.getDate()).slice(-2);

            if (groupingCriteria === "day") {
                return `${year}-${month}-${day}`;
            } else if (groupingCriteria === "month") {
                return `${year}-${month}`;
            } else if (groupingCriteria === "year") {
                return `${year}`;
            }
        }

        function getMostRecentDate(surveyGroup, sortMethod) {
            return surveyGroup.reduce((maxDate, survey) => {
                const date = new Date(formatDate(survey[sortMethod]));
                return date > maxDate ? date : maxDate;
            }, new Date(0));
        }

        // Group surveys by campaign first
        const groupedByCampaign = {};
        surveys.forEach(survey => {
            const campaignName = survey.config.campaign && survey.config.campaign.trim() !== "" ? survey.config.campaign : "no_campaign";

            if (!groupedByCampaign[campaignName]) {
                groupedByCampaign[campaignName] = [];
            }

            groupedByCampaign[campaignName].push(survey);
        });

        // Group surveys and campaigns by the specified criteria
        const groupedByCriteria = {};
        Object.values(groupedByCampaign).forEach(group => {
            const isSurveyGroup = group[0]?.config?.campaign && group[0].config.campaign.trim() !== "";
            const groupMostRecentDate = getMostRecentDate(group, sortMethod);
            const groupKey = getGroupKey(groupMostRecentDate);

            if (!groupedByCriteria[groupKey]) {
                groupedByCriteria[groupKey] = [];
            }

            if (isSurveyGroup) {
                // push campaigns to date groups
                groupedByCriteria[groupKey].push(group);
            } else {
                // push individual surveys to date groups
                group.forEach(survey => {
                   const surveyKey = getGroupKey(new Date(formatDate(survey[sortMethod])))
                    if (!groupedByCriteria[surveyKey]) {
                        groupedByCriteria[surveyKey] = []
                    }
                    groupedByCriteria[surveyKey].push(survey);
                });
            }
        });

        // sort date groups by sort direction
        const sortedKeys = Object.keys(groupedByCriteria).sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return sortDirection ? dateB - dateA : dateA - dateB;
        });

        const sortedAndCombined = {};

        // sort surveys and campaigns inside date groups by Updated, starttime, or endtime
        sortedKeys.forEach(key => {
            const groups = groupedByCriteria[key];
            // sort inside campaigns
            const groupsWithCampaignsSorted = []
            for (const item of groups) {
                if (Array.isArray(item)) {
                    const sortArray = item.sort((a, b) => {
                        const dateA = new Date(formatDate(a[sortMethod]))
                        const dateB = new Date(formatDate(b[sortMethod]))
                        if (sortMethod === "starttime") {
                            return dateA - dateB
                        }
                        return sortDirection ? dateB - dateA : dateA - dateB;
                    })
                    groupsWithCampaignsSorted.push(sortArray)
                } else {
                    groupsWithCampaignsSorted.push(item)
                }
            }
            // sort surveys with most recent survey of campaign
            const sorted = groupsWithCampaignsSorted.sort((a, b) => {
                const dateA = Array.isArray(a) ? getMostRecentDate(a, sortMethod) : new Date(formatDate(a[sortMethod]));
                const dateB = Array.isArray(b) ? getMostRecentDate(b, sortMethod) : new Date(formatDate(b[sortMethod]));
                if (sortMethod === "starttime") {
                    return dateA - dateB
                }
                return sortDirection ? dateB - dateA : dateA - dateB;
            });
            sortedAndCombined[key] = sorted;
        });

        return sortedAndCombined;
    }


    if (status === 'success' && getUseCases.isSuccess) {
        const useCasesData = getUseCases?.data[0] || {}

        searchData = data.filter(survey => {
            const config = survey.config
            const hasTitle = config && config.hasOwnProperty("title")
            const hasCampaign = config && config.hasOwnProperty("campaign")

            const titleMatches = hasTitle && config.title.toLowerCase().includes(searchText.toLowerCase())
            const campaignMatches = hasCampaign && config.campaign.toLowerCase().includes(searchText.toLowerCase())

            const useCaseKey = config?.usecase || ''
            const useCaseData = useCasesData[useCaseKey] || {}
            const useCaseTitle = useCaseKey
                ? intl.formatMessage({
                    id: `usecase.${useCaseKey}.title`,
                    defaultMessage: useCaseData.title || useCaseKey,
                })
                : ''

            const useCaseMatches = useCaseTitle.toLowerCase().includes(searchText.toLowerCase());

            return (titleMatches || campaignMatches || useCaseMatches)
        })

        sortedCombinedGroups = groupAndSortSurveys(searchData, groupingSpan, sortMethod, sortDirection)
    }

    return (
        <div className={"content"}>
            <h1>
                {intl.formatMessage(
                    {
                        id: 'main.surveys.surveys',
                        defaultMessage: 'Surveys',
                    }
                )}
            </h1>
            <Link to={`/survey/new`} className={"create-new button"}>
                <PlusIcon />
                {intl.formatMessage(
                    {
                        id: 'main.surveys.createNew',
                        defaultMessage: 'Create New Survey',
                    }
                )}
            </Link>
            <div className={"surveys-layout"}>
                <div className={"surveys-sidebar"}>
                    <div className={"survey-sidebar-container"}>
                        <div className={"search-sort-surveys"}>
                            <input type={"text"} className={"search"} value={searchText}
                                   onChange={e => {
                                       setSearchText(e.target.value)
                                   }}
                                   placeholder={intl.formatMessage(
                                       {
                                           id: 'main.surveys.search.placeholder',
                                           defaultMessage: 'Search for survey',
                                       })}/>
                        </div>
                        <form onChange={e => {
                            localStorage.setItem("showStatus", e.target.value)
                            setShowStatus(e.target.value)
                        }}>
                            <fieldset className={"radio-group by-status"}>
                                <legend>
                                    {intl.formatMessage(
                                        {
                                            id: 'main.surveys.showByStatus',
                                            defaultMessage: 'Show by Status',
                                        })}
                                </legend>
                                <div>
                                    <input type="radio" id="all-surveys" name="show-by-status" value={"all"} defaultChecked={showStatus === "all"}/>
                                    <label htmlFor="all-surveys">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.status.all',
                                                defaultMessage: 'All',
                                            })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="draft-surveys" name="show-by-status" value={"draft"} defaultChecked={showStatus === "draft"}/>
                                    <label htmlFor="draft-surveys">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.status.draft',
                                                defaultMessage: 'Draft',
                                            })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="scheduled-surveys" name="show-by-status" value={"scheduled"} defaultChecked={showStatus === "scheduled"}/>
                                    <label htmlFor="scheduled-surveys">
                                        {intl.formatMessage(
                                        {
                                            id: 'main.surveys.status.scheduled',
                                            defaultMessage: 'Scheduled',
                                        })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="in-progress-surveys" name="show-by-status" value={"inProgress"} defaultChecked={showStatus === "inProgress"}/>
                                    <label htmlFor="in-progress-surveys">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.status.inProgress',
                                                defaultMessage: 'In Progress',
                                            })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="finished-surveys" name="show-by-status" value={"finished"} defaultChecked={showStatus === "finished"}/>
                                    <label htmlFor="finished-surveys">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.status.finished',
                                                defaultMessage: 'Finished',
                                            })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="archived-surveys" name="show-by-status" value={"archived"} defaultChecked={showStatus === "archived"}/>
                                    <label htmlFor="archived-surveys">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.status.archived',
                                                defaultMessage: 'Archived',
                                            })}
                                    </label>
                                </div>
                            </fieldset>
                        </form>
                        <form onChange={e => {
                            setSortMethod(e.target.value)
                            localStorage.setItem("sortMethod", e.target.value)
                        }}>
                            <fieldset className={"radio-group"}>
                                <legend className={"toggle-header"} onClick={()=> {
                                    setSortDirection(!sortDirection)
                                    localStorage.setItem("sortDirection", JSON.stringify(!sortDirection))
                                }} role="button" aria-pressed={sortDirection} aria-label={"Change Sort Direction"}>
                                    {intl.formatMessage(
                                        {
                                            id: 'main.surveys.sort',
                                            defaultMessage: 'Sort by',
                                        })}
                                    <span className={!sortDirection ? "asc sort-icon" : "desc sort-icon"}>
                                        <SortOrderIcon />
                                    </span>
                                </legend>
                                <div>
                                    <input type="radio" id="sort-by-updated" name="sort-by" value={"updated"} defaultChecked={sortMethod === "updated"}/>
                                    <label htmlFor="sort-by-updated">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.sort.updated',
                                                defaultMessage: 'Updated',
                                            })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="sort-by-starttime" name="sort-by" value={"starttime"} defaultChecked={sortMethod === "starttime"}/>
                                    <label htmlFor="sort-by-starttime">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.sort.starttime',
                                                defaultMessage: 'Start Time',
                                            })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="sort-by-endtime" name="sort-by" value={"endtime"} defaultChecked={sortMethod === "endtime"}/>
                                    <label htmlFor="sort-by-endtime">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.sort.endtime',
                                                defaultMessage: 'End Time',
                                            })}
                                    </label>
                                </div>
                            </fieldset>
                        </form>
                        <form disabled={sortMethod === "alphabetical"} onChange={e => {
                            setGroupingSpan(e.target.value)
                            localStorage.setItem("groupingSpan", e.target.value)
                        }}>
                            <fieldset className={"radio-group"}>
                                <legend>{intl.formatMessage(
                                    {
                                        id: 'main.surveys.group',
                                        defaultMessage: 'Group by',
                                    })}
                                </legend>
                                <div>
                                    <input type="radio" id="span-day" name="grouping-span" value={"day"} defaultChecked={groupingSpan === "day"}/>
                                    <label htmlFor="span-day">
                                        {intl.formatMessage(
                                        {
                                            id: 'main.surveys.group.day',
                                            defaultMessage: 'Day',
                                        })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="span-month" name="grouping-span" value={"month"} defaultChecked={groupingSpan === "month"}/>
                                    <label htmlFor="span-month">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.group.month',
                                                defaultMessage: 'Month',
                                            })}
                                    </label>
                                </div>
                                <div>
                                    <input type="radio" id="span-year" name="grouping-span" value={"year"} defaultChecked={groupingSpan === "year"}/>
                                    <label htmlFor="span-year">
                                        {intl.formatMessage(
                                            {
                                                id: 'main.surveys.group.year',
                                                defaultMessage: 'Year',
                                            })}
                                    </label>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
                <div className={"surveys-main"}>
                    <div className={sortMethod === "alphabetical" ? "surveys surveys-container" : "surveys"}>
                        {
                            status === "loading" || getCopyOfSurveyText.isLoading || getUseCases.isLoading ? <LoadingSkeleton /> :
                                status === "error" || getUseCases.isError ? <span>Error: {error.message}</span> :
                                    <>
                                        {!_.isEmpty(sortedCombinedGroups) ?
                                                Object.keys(sortedCombinedGroups).map((group, i) => {
                                                        return <SearchGroup searchGroups={sortedCombinedGroups[group]}
                                                                            group={group} groupingSpan={groupingSpan}
                                                                            key={group+i} refetch={() => refetch()}
                                                                            copyOfText={(Array.isArray(getCopyOfSurveyText?.data) && getCopyOfSurveyText?.data?.length > 0) ? getCopyOfSurveyText?.data[0] : null}
                                                                            useCasesData={getUseCases?.data[0]}
                                                        />
                                                    }
                                                )
                                            :
                                            <p>
                                                {intl.formatMessage(
                                                    {
                                                        id: 'main.surveys.noSurveys',
                                                        defaultMessage: 'No surveys to display.',
                                                    })}
                                            </p>}
                                        {isFetching ? <div className={"loader-container"}><Loader /></div> : ""}
                                    </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function SearchGroup({searchGroups, group, groupingSpan, refetch, copyOfText, useCasesData}) {
    const [groupVisibility, setGroupVisibility] = useState(true)
    const intl = useIntl()
    let date = new Date(group)
    let dateDisplay
    let locale = (intl.locale === "es" || intl.locale === "it") ? "en" : intl.locale
    switch (groupingSpan) {
        case "day":
            dateDisplay = date.getDate() + " " + date.toLocaleString(locale, { month: 'long' }) + " " + date.getFullYear()
            break
        case "month":
            dateDisplay = date.toLocaleString(locale, { month: 'long' }) + " " + date.getFullYear()
            break
        case "year":
            dateDisplay = date.getFullYear()
            break
        default:
            dateDisplay = date.getMonth()
    }
    return <div className={"search-group"}>
        <div className={"group-divider"} onClick={()=>setGroupVisibility(!groupVisibility)}>
            <p>
                <span className={groupVisibility ? "chevron" : "chevron closed"}>
                    <Chevron />
                </span>
                {dateDisplay}
            </p>
        </div>
        {groupVisibility &&
        <div className={"surveys-container"}>
            {searchGroups.map((survey) => {
                    if (Array.isArray(survey)) {
                        return <Campaign campaign={survey} key={survey[0]?.id} refetch={refetch} copyOfText={copyOfText} useCasesData={useCasesData}/>
                    }
                    return <Survey survey={survey} key={survey.id} refetch={refetch} copyOfText={copyOfText} useCasesData={useCasesData}/>
                }
            )}
        </div>
        }
    </div>
}

function Campaign({ campaign, refetch, copyOfText, useCasesData }) {
    const intl = useIntl()
    const [showPopup, setShowPopup] = useState(false)
    const campaignName = campaign[0]?.config?.campaign
    const campaignAmounts = campaign?.length ? "("+campaign?.length+")" : ""
    return <><div className={"campaign"}>
        <h3 onClick={()=>setShowPopup(true)} title={intl.formatMessage({id:'edit',defaultMessage:'Edit'})}>{campaignName} {campaignAmounts}</h3>
        <div className={"surveys-in-campaign"}>
            {campaign.map((survey) => {
                return <Survey survey={survey} key={survey?.id} refetch={refetch} copyOfText={copyOfText} useCasesData={useCasesData}/>
            })}
        </div>
    </div>
        {showPopup &&
            <RenameCampaignPopup campaign={campaign} campaignName={campaignName} refetch={refetch} closePopup={()=>setShowPopup(false)}/>
        }
        </>
}

function RenameCampaignPopup({ campaignName, campaign, refetch, closePopup }) {
    const intl = useIntl()
    const [newCampaignName, setNewCampaignName] = useState(campaignName)
    const {setSnackbarData} = useSnackbar()
    const [surveys, setSurveys] = useState([])
    const [archivedSurveys, setArchivedSurveys] = useState([])
    const getSurveys = GetSurveys()
    const getArchivedSurveys = GetSurveys("ARCHIVED")
    const [editArchived, setEditArchived] = useState(false)

    useEffect(()=>{
        if (getSurveys.isSuccess) {
            const filteredData = getSurveys?.data.filter(survey => survey?.config?.campaign === campaignName)
            setSurveys(filteredData)
        }
    },[getSurveys?.data])

    useEffect(()=>{
        if (getArchivedSurveys.isSuccess) {
            const filteredData = getArchivedSurveys?.data.filter(survey => survey?.config?.campaign === campaignName)
            setArchivedSurveys(filteredData)
        }
    },[getArchivedSurveys?.data])

    const handleCampaignUpdate = async () => {
        const surveyArray = editArchived ? [...surveys, ...archivedSurveys] : surveys

        const updateCampaignName = async (survey) => {
            const updatedSurvey = { ...survey }
            updatedSurvey.config.campaign = newCampaignName.trim()
            await updateSurvey(updatedSurvey, survey.id)
        };

        const updatePromises = surveyArray.map((survey) => updateCampaignName(survey))

        try {
            await Promise.all(updatePromises)

            setSnackbarData({
                show: true,
                text: intl.formatMessage({ id: 'campaignRenamed', defaultMessage: "Campaign renamed!" }),
                state: "success",
                autoHide: true,
            });

            closePopup()
            refetch()
        } catch (error) {
            console.log(error)
            setSnackbarData({
                show: true,
                text: intl.formatMessage({ id: 'campaignRenameFailed', defaultMessage: "Campaign renaming failed. Please try again." }),
                state: "error",
                autoHide: true,
            })
        }
    }



    const isLoading = getSurveys.isLoading || getArchivedSurveys.isLoading

    return <Popup closePopup={closePopup}>
        <h1>
            {intl.formatMessage({id:'renameCampagin', defaultMessage:'Rename campaign'})}
        </h1>
        <input
            type="text"
            value={newCampaignName}
            onChange={(e) => setNewCampaignName(e.target.value)}
            autoFocus
        />
        {archivedSurveys?.length > 0 &&
        <label className={"checkbox-label flex"}>
            <input
                type="checkbox"
                id="editArchived"
                checked={editArchived}
                onChange={(event) => setEditArchived(event.target.checked)}
            />
            <label htmlFor="editArchived">
                <FormattedMessage
                    id={"renameCampaignNameForArchived"}
                    defaultMessage={"Found archived surveys with the same campaign name.{br}Rename these as well?"}
                    values={{br: <br/>}}/>
            </label>
        </label>
        }
        <div className={"modal-options"}>
            <button className={"cancel"} onClick={closePopup}>
                {intl.formatMessage({
                    id: 'modal.cancel',
                    defaultMessage: 'Cancel',
                })}
            </button>
            {newCampaignName?.length < 1 || campaignName === newCampaignName || isLoading ?
                <button disabled className={"confirm"}>
                    {isLoading ?
                        intl.formatMessage({
                            id: 'loading',
                            defaultMessage: 'Loading...',
                        }) :
                        intl.formatMessage({
                            id: 'rename',
                            defaultMessage: 'Rename',
                        })
                    }
                    {}
                </button> :
                <button className={"confirm"} onClick={handleCampaignUpdate}>
                    {intl.formatMessage({
                        id: 'rename',
                        defaultMessage: 'Rename',
                    })}
                </button>
            }
        </div>
    </Popup>
}

function Survey({survey, refetch, copyOfText, useCasesData}) {
    const config = survey?.config
    const [showDuplicatePopup, setShowDuplicatePopup] = useState(false)
    const [showArchivePopup, setShowArchivePopup] = useState(false)
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    const [showCampaignPopup, setShowCampaignPopup] = useState(false)
    const [draggedSurvey, setDraggedSurvey] = useState(null)
    const [removeCampaignFromSurvey, setRemoveCampaignFromSurvey] = useState(false)
    let startTime = new Date(formatDate(survey.starttime))
    let endTime = new Date(formatDate(survey.endtime))
    const surveyName = config.title
    const surveyUseCase = config?.usecase || ''
    const surveyUseCaseData = useCasesData?.[surveyUseCase]
    const surveyRecipients = survey.hasOwnProperty("contacts") && survey.contacts ? survey.contacts.length : 0
    const intl = useIntl()

    const useCaseTitle = surveyUseCase
        ? intl.formatMessage({
            id: `usecase.${surveyUseCase}.title`,
            defaultMessage: surveyUseCaseData?.title || surveyUseCase,
        })
        : '';

    const useCaseDescription = surveyUseCase
        ? intl.formatMessage({
            id: `usecase.${surveyUseCase}.description`,
            defaultMessage: surveyUseCaseData?.description || useCaseTitle || surveyUseCase,
        })
        : '';

    const handleDragStart = (event, survey) => {
        event.dataTransfer.setData('text/plain', JSON.stringify(survey));
        setDraggedSurvey(survey);
    }

    const handleDragOver = (event) => {
        event.preventDefault();
    }

    const handleDrop = (event, targetSurvey) => {
        event.preventDefault();
        const campaignData = JSON.parse(event.dataTransfer.getData('text/plain'));

        if (campaignData.id !== targetSurvey.id) {
            setShowCampaignPopup(true)
            setRemoveCampaignFromSurvey(false)
        }

        setDraggedSurvey(campaignData)
    }

    return <>
        <Link to={`/survey/${survey.id}`}
              draggable
              onDragStart={(event) => handleDragStart(event, survey)}
              onDrop={(event) => handleDrop(event, survey)}
              onDragOver={handleDragOver}
              className={survey.status === 'DRAFT' ? 'survey draft' : 'survey'}>
            <OptionsPopover surveyData={survey}
                            setShowDuplicatePopup={() => setShowDuplicatePopup(true)}
                            setShowArchivePopup={() => setShowArchivePopup(true)}
                            setShowDeletePopup={() => setShowDeletePopup(true)}
                            setShowRemoveFromCampaign={()=>{
                                setRemoveCampaignFromSurvey(true)
                                setShowCampaignPopup(true)
                                setDraggedSurvey(survey)
                            }}
            />
            <h3>
                {surveyName}
            </h3>
            {surveyUseCase &&
                <p className={"survey-use-case"} title={useCaseDescription}>
                    {useCaseTitle}
                </p>
            }
            <p className={"recipients"} title={intl.formatMessage({
                id: 'survey.overview.recipients',
                defaultMessage: 'Recipients',
            })}>
                {surveyRecipients} <ContactsIcon />
            </p>
            <p>
                {startTime.getDate()}.{startTime.getMonth()+1}.{startTime.getFullYear()} {startTime.getHours()}.{startTime.getMinutes() < 10 ? '0' : ""}{startTime.getMinutes()} –<br/>
                {endTime.getDate()}.{endTime.getMonth()+1}.{endTime.getFullYear()} {endTime.getHours()}.{endTime.getMinutes() < 10 ? '0' : ""}{endTime.getMinutes()}
            </p>
            <StatusText survey={survey}/>
        </Link>
        {showDuplicatePopup &&
            <CopyPopup survey={survey} closePopup={()=>setShowDuplicatePopup(false)} refetch={refetch} copyOfText={copyOfText}/>
        }
        {showArchivePopup &&
            <ArchivePopup survey={survey} closePopup={()=>setShowArchivePopup(false)} refetch={refetch}/>
        }
        {showDeletePopup &&
            <DeletePopup survey={survey} closePopup={()=>setShowDeletePopup(false)} refetch={refetch}/>
        }
        {showCampaignPopup && (
            <CampaignPopup
                draggedSurvey={draggedSurvey}
                targetSurvey={survey}
                closePopup={() => setShowCampaignPopup(false)}
                refetch={refetch}
                removeCampaignFromSurvey={removeCampaignFromSurvey}
            />
        )}
    </>
}

function CampaignPopup({ draggedSurvey, targetSurvey, closePopup, refetch, removeCampaignFromSurvey }) {
    const intl = useIntl()
    const [campaignName, setCampaignName] = useState(
        targetSurvey?.config?.campaign && targetSurvey?.config?.campaign.trim() !== ''
            ? targetSurvey?.config?.campaign
            : ''
    )
    const addSurveyToCampaign = targetSurvey?.config?.campaign && targetSurvey?.config?.campaign.trim() !== ''
    const createNewCampaign = !removeCampaignFromSurvey && !addSurveyToCampaign
    const draggedTitle = draggedSurvey?.config?.title
    const targetTitle = targetSurvey?.config?.title
    const currentCampaign = draggedSurvey?.config?.campaign

    const renderTitle = () => {
        if (removeCampaignFromSurvey) {
            return (
                <>
                    {intl.formatMessage({
                        id: 'removeSurvey',
                        defaultMessage: 'Remove survey',
                    })}<br/>
                    <b className={"margin"}>{draggedTitle}</b>
                    {intl.formatMessage({
                        id: 'fromCampaign',
                        defaultMessage: 'from campaign',
                    })}<br/>
                    <b>{currentCampaign}</b>?
                </>
            );
        }
        if (addSurveyToCampaign) {
            return (
                <>
                    {intl.formatMessage({
                        id: 'addSurvey',
                        defaultMessage: 'Add survey',
                    })}<br/>
                    <b className={"margin"}>{draggedTitle}</b>
                    {intl.formatMessage({
                        id: 'toCampaign',
                        defaultMessage: 'to campaign',
                    })}<br/>
                    <b>{campaignName}</b>?
                </>
            );
        }
        if (createNewCampaign) {
            return <>
                {intl.formatMessage({
                    id: 'createANewCampaignForSurveys',
                    defaultMessage: 'Create a new campaign for surveys',
                })}<br/>
                <b>{draggedTitle}</b> & <b>{targetTitle}</b>
            </>
        }
    }

    const draggedSurveyUpdate = UpdateSurveyWithId(draggedSurvey.id)
    const targetSurveyUpdate = UpdateSurveyWithId(targetSurvey.id)
    const {setSnackbarData} = useSnackbar()

    const handleCampaignUpdate = () => {
        if (removeCampaignFromSurvey) {
            const newSurveyData = {...draggedSurvey}
            newSurveyData.config.campaign = ""
            draggedSurveyUpdate.mutate(newSurveyData, {
                onError: () => {
                    setSnackbarData({
                        show: true,
                        text: intl.formatMessage({id:'removingSurveyFromCampaignFailed', defaultMessage:"Removing survey from campaign failed. Please try again."}),
                        state: "error",
                        autoHide: true,
                    })
                },
                onSuccess: () => {
                    setSnackbarData({
                        show: true,
                        text: intl.formatMessage({id:'surveyRemovedFromCampaign', defaultMessage:"Survey removed from campaign!"}),
                        state: "success",
                        autoHide: true,
                    })
                    closePopup()
                    refetch()
                }
            })
        } else if (addSurveyToCampaign) {
            const newSurveyData = {...draggedSurvey}
            newSurveyData.config.campaign = campaignName.trim()
            draggedSurveyUpdate.mutate(newSurveyData, {
                onError: () => {
                    setSnackbarData({
                        show: true,
                        text: intl.formatMessage({id:'addingSurveyToCampaignFailed', defaultMessage:"Adding survey to campaign failed. Please try again."}),
                        state: "error",
                        autoHide: true,
                    })
                },
                onSuccess: () => {
                    setSnackbarData({
                        show: true,
                        text: intl.formatMessage({id:'surveyAddedToCampaign', defaultMessage:"Survey added to campaign!"}),
                        state: "success",
                        autoHide: true,
                    })
                    closePopup()
                    refetch()
                }
            })
        } else if (createNewCampaign) {
            const newDraggedSurvey = {...draggedSurvey}
            newDraggedSurvey.config.campaign = campaignName.trim()
            const newTargetSurvey = {...targetSurvey}
            newTargetSurvey.config.campaign = campaignName.trim()
            Promise.all([
                new Promise((resolve, reject) => draggedSurveyUpdate.mutate(newDraggedSurvey, {
                    onError: () => reject(),
                    onSuccess: () => resolve(),
                })),
                new Promise((resolve, reject) => targetSurveyUpdate.mutate(newTargetSurvey, {
                    onError: () => reject(),
                    onSuccess: () => resolve(),
                })),
            ])
                .then(() => {
                    setSnackbarData({
                        show: true,
                        text: intl.formatMessage({id:'campaignCreatedWithSurveys', defaultMessage:"Campaign created with surveys!"}),
                        state: "success",
                        autoHide: true,
                    });
                    closePopup();
                    refetch();
                })
                .catch(() => {
                    setSnackbarData({
                        show: true,
                        text: intl.formatMessage({id:'creatingCampaignFromSurveysFailed', defaultMessage:"Creating campaign with surveys failed. Please try again."}),
                        state: "error",
                        autoHide: true,
                    });
                });
        }
    }

     return <Popup closePopup={closePopup}>
        <h1>
            {renderTitle()}
        </h1>
         {createNewCampaign &&
         <input
             type="text"
             value={campaignName}
             onChange={(e) => setCampaignName(e.target.value)}
             placeholder={intl.formatMessage({id:'newCampaignName', defaultMessage:'New campaign name'})}
             autoFocus
         />
         }
        <div className={"modal-options"}>
            <button className={"cancel"} onClick={closePopup}>
                {intl.formatMessage({
                    id: 'modal.cancel',
                    defaultMessage: 'Cancel',
                })}
            </button>
            {!removeCampaignFromSurvey && campaignName?.length < 1 ?
                <button disabled className={"confirm"}>
                    {addSurveyToCampaign ?
                        intl.formatMessage({
                            id: 'addToCampaign',
                            defaultMessage: 'Add to campaign',
                        })
                        :
                        intl.formatMessage({
                            id: 'createCampaign',
                            defaultMessage: 'Create campaign',
                        })}
                </button> :
                <button className={`confirm ${removeCampaignFromSurvey ? 'alert' : ''}`} onClick={handleCampaignUpdate}>
                    {removeCampaignFromSurvey ?
                        intl.formatMessage({
                            id: 'removeFromCampaign',
                            defaultMessage: 'Remove from campaign',
                        })
                        :
                        addSurveyToCampaign ?
                            intl.formatMessage({
                                id: 'addToCampaign',
                                defaultMessage: 'Add to campaign',
                            })
                            :
                            intl.formatMessage({
                                id: 'createCampaign',
                                defaultMessage: 'Create campaign',
                            })
                    }
                </button>
            }
        </div>
    </Popup>
}

function DeletePopup({survey, closePopup, refetch}) {
    const surveyUpdate = UpdateSurveyWithId(survey.id)
    const {authData} = useAuthData()
    const intl = useIntl()
    const {setSnackbarData} = useSnackbar()

    const deleteSurvey = () => {
        const newSurveyData = {...survey}
        newSurveyData.status = "DELETED"
        newSurveyData.updatedby = authData.uid
        newSurveyData.updated = updateTimeToServerFormat(new Date())
        surveyUpdate.mutate(newSurveyData, {
            onError: () => {
                setSnackbarData({
                    show: true,
                    text: "Deleting survey failed. Please try again.",
                    state: "error",
                    autoHide: true,
                })
            },
            onSuccess: () => {
                setSnackbarData({
                    show: true,
                    text: "Survey deleted.",
                    state: "success",
                    autoHide: true,
                })
                closePopup()
                refetch()
            }
        })
    }

    return <Popup closePopup={() => closePopup()}>
        <h1>
            {intl.formatMessage({
                id: 'survey.delete.header',
                defaultMessage: 'Delete Survey',
            })}
            <b> {survey.config.title}</b>
        </h1>
        <p>
            {intl.formatMessage({
                id: 'survey.delete.text',
                defaultMessage: 'Are you sure you want to delete this survey?',
            })}
        </p>
        <div className={"modal-options"}>
            <button className={"cancel"} onClick={()=>closePopup()}>
                {intl.formatMessage({
                    id: 'modal.cancel',
                    defaultMessage: 'Cancel',
                })}
            </button>
            <button className={"confirm alert"} onClick={()=>deleteSurvey()}>
                {intl.formatMessage({
                    id: 'survey.delete',
                    defaultMessage: 'Delete',
                })}
            </button>
        </div>
    </Popup>
}

function ArchivePopup({survey, closePopup, refetch}) {
    const intl = useIntl()
    const {setSnackbarData} = useSnackbar()
    const surveyUpdate = UpdateSurveyWithId(survey?.id)
    const archiving = surveyUpdate.isLoading

    const archiveSurvey = () => {
        const newSurveyData = {...survey}
        newSurveyData.status = "ARCHIVED"
        surveyUpdate.mutate(newSurveyData, {
            onError: error => {
                setSnackbarData({
                    show: true,
                    text: intl.formatMessage({
                        id: 'survey.archive.success',
                        defaultMessage: 'Archiving survey failed. Please try again.',
                    }),
                    state: "error",
                    autoHide: true,
                })
                console.error(error)
            },
            onSuccess: () => {
                setSnackbarData({
                    show: true,
                    text: intl.formatMessage({
                            id: 'survey.archive.success',
                            defaultMessage: 'Survey archived',
                        }),
                    state: "success",
                    autoHide: true,
                })
                closePopup()
                refetch()
            }
        })
    }

    return <Popup closePopup={() => closePopup()}>
        {archiving ?
        <>
            <h1>
                {intl.formatMessage({
                    id: 'survey.archive.header.archiving',
                    defaultMessage: 'Archiving Survey',
                })}
                <b> {survey.config.title}</b>
            </h1>
            <p className={"loading"}>
                <LoadingIcon />
                {intl.formatMessage({
                    id: 'survey.archive.archiving',
                    defaultMessage: 'Please wait. Archiving...',
                })}
            </p>
            <div className={"modal-options"}>
                <button className={"cancel"} disabled>
                    {intl.formatMessage({
                        id: 'modal.cancel',
                        defaultMessage: 'Cancel',
                    })}
                </button>
                <button className={"confirm"} disabled>
                    {intl.formatMessage({
                        id: 'survey.archive',
                        defaultMessage: 'archive',
                    })}
                </button>
            </div>
        </> :
            <>
                <h1>
                    {intl.formatMessage({
                        id: 'survey.archive.header',
                        defaultMessage: 'Archive Survey',
                    })}
                    <b> {survey.config.title}</b>
                </h1>
                <p>
                    {intl.formatMessage({
                        id: 'survey.archive.text',
                        defaultMessage: 'Are you sure you want to archive this survey?',
                    })}
                </p>
                <div className={"modal-options"}>
                    <button className={"cancel"} onClick={()=>closePopup()}>
                        {intl.formatMessage({
                            id: 'modal.cancel',
                            defaultMessage: 'Cancel',
                        })}
                    </button>
                    <button className={"confirm"} onClick={()=>archiveSurvey()}>
                        {intl.formatMessage({
                            id: 'survey.archive',
                            defaultMessage: 'archive',
                        })}
                    </button>
                </div>
            </>
        }
    </Popup>
}

export function CopyPopup({survey, closePopup, refetch, duplicateFromSurveyEditor, setNewIdForNavigation, copyOfText}) {
    const newID = JSON.stringify(new Date().getTime())
    const surveyPost = PostSurveyWithId(newID)
    const annieUserSurveyPost = PostUsersToAnnieUserSurvey()
    const [copyRecipients, setCopyRecipients] = useState(false)
    const [copySupportProviders, setCopySupportProviders] = useState(false)
    const [copyCampaign, setCopyCampaign] = useState(false)
    const supportProviders = GetUserBySurvey(survey.id)
    const intl = useIntl()
    const {authData} = useAuthData()
    const {setSnackbarData} = useSnackbar()

    const duplicateSurvey = () => {
        const newSurveyData = {...survey}
        // Clean branches of excess keys
        const cleanedSurveyData = removeUnnecessaryKeys(newSurveyData)

        const copyOfTranslation = copyOfText?.value ? copyOfText.value : intl.formatMessage({defaultMessage:'Copy of', id:'copyOfSurvey'})

        cleanedSurveyData.config.title = copyOfTranslation + " " + newSurveyData.config.title
        cleanedSurveyData.updated = updateTimeToServerFormat(new Date())
        cleanedSurveyData.updatedby = authData.uid
        cleanedSurveyData.status = "DRAFT"
        cleanedSurveyData.id = newID
        if (!copyRecipients) {
            cleanedSurveyData.contacts = []
        }
        if (!copyCampaign) {
            cleanedSurveyData.config.campaign = ""
        }
        if (copySupportProviders) {
            if (supportProviders.isSuccess) {
                const newSupportProviders = [...supportProviders.data]
                for (let i = 0; i < newSupportProviders.length; i++) {
                    newSupportProviders[i].survey = newID
                }
                surveyPost.mutate(cleanedSurveyData, {
                    onError: () => {
                        setSnackbarData({
                            show: true,
                            text: "Error in duplicating survey. Please try again.",
                            state: "error",
                            autoHide: true,
                        })
                    },
                    onSuccess: () => {
                        annieUserSurveyPost.mutate(newSupportProviders, {
                            onError: () => {
                                setSnackbarData({
                                    show: true,
                                    text: "Error copying users. Please try again.",
                                    state: "error",
                                    autoHide: true,
                                })
                            },
                            onSuccess: () => {
                                setSnackbarData({
                                    show: true,
                                    text: intl.formatMessage(
                                        {
                                            id: 'toast.surveyDuplicated',
                                            defaultMessage: 'Survey duplicated',
                                        }),
                                    state: "success",
                                    autoHide: true,
                                })
                                !duplicateFromSurveyEditor && closePopup()
                                duplicateFromSurveyEditor && setNewIdForNavigation(newID)
                                refetch()
                            }
                        })
                    }
                })
            }
        } else {
            surveyPost.mutate(cleanedSurveyData, {
                onError: () => {
                    setSnackbarData({
                        show: true,
                        text: "Error in duplicating survey. Please try again.",
                        state: "error",
                        autoHide: true,
                    })
                },
                onSuccess: () => {
                    setSnackbarData({
                        show: true,
                        text: intl.formatMessage(
                            {
                                id: 'toast.surveyDuplicated',
                                defaultMessage: 'Survey duplicated',
                            }),
                        state: "success",
                        autoHide: true,
                    })
                    !duplicateFromSurveyEditor && closePopup()
                    duplicateFromSurveyEditor && setNewIdForNavigation(newID)
                    refetch()
                }
            })
        }
    }

    return <Popup closePopup={() => closePopup()}>
        <h1>
            {intl.formatMessage({
                id: 'survey.duplicate.header',
                defaultMessage: 'Duplicate Survey',
            })}
            <b> {survey.config.title}</b>
        </h1>
        <p>
            {intl.formatMessage({
                id: 'survey.duplicate.options',
                defaultMessage: 'Also copy from survey:',
            })}
        </p>
        <div className={"options-container"}>
            <div>
                <input id={"check-campaign"} type={"checkbox"} checked={copyCampaign} onChange={()=>setCopyCampaign(!copyCampaign)}/>
                <label htmlFor={"check-campaign"}>
                    {intl.formatMessage({
                        id: 'campaignName',
                        defaultMessage: 'Campaign name',
                    })}
                </label>
            </div>
            <div>
                <input id={"check-contacts"} type={"checkbox"} checked={copyRecipients} onChange={()=>setCopyRecipients(!copyRecipients)}/>
                <label htmlFor={"check-contacts"}>
                    {intl.formatMessage({
                        id: 'survey.navigation.recipients',
                        defaultMessage: 'Recipients',
                    })}
                </label>
            </div>
            <div>
                <input id={"check-providers"} type={"checkbox"} checked={copySupportProviders} onChange={()=>setCopySupportProviders(!copySupportProviders)}/>
                <label htmlFor={"check-providers"}>
                    {intl.formatMessage({
                        id: 'survey.duplicate.supportProviders',
                        defaultMessage: 'Support Providers & Coordinators',
                    })}
                </label>
            </div>
        </div>
        <div className={"modal-options"}>
            <button className={"cancel"} onClick={()=>closePopup()}>
                {intl.formatMessage({
                    id: 'modal.cancel',
                    defaultMessage: 'Cancel',
                })}
            </button>
            <button className={"confirm"} onClick={()=>duplicateSurvey()}>
                {intl.formatMessage({
                    id: 'survey.duplicate',
                    defaultMessage: 'Duplicate',
                })}
            </button>
        </div>
    </Popup>
}

function OptionsPopover({setShowDuplicatePopup, setShowArchivePopup, setShowDeletePopup, surveyData, setShowRemoveFromCampaign}) {
    const surveyIsFinished = surveyData.hasOwnProperty("status") && surveyData.status === "FINISHED"
    const surveyIsDraft = surveyData.hasOwnProperty("status") && surveyData.status === "DRAFT"
    const {currentUserData} = useCurrentUserData()
    const isSuperUser = currentUserData.hasOwnProperty("superuser") && currentUserData.superuser
    const [popoverOpen, setPopoverOpen] = useState(false)
    const intl = useIntl()
    const surveyHasCampaign = surveyData && surveyData?.config && surveyData?.config?.campaign && surveyData?.config?.campaign?.length > 0

    return <div className={"options-popover popover-container"} onClick={(e)=> {
        e.preventDefault()
        e.stopPropagation()
    }}>
        <div className={"popover-toggle"} onClick={(e)=> {
            setPopoverOpen(true)
        }}>
            <OptionsIcon />
        </div>
        {popoverOpen &&
        <Popover closePopover={() => setPopoverOpen(false)}>
            <p onClick={() => {
                setShowDuplicatePopup()
            }}>
                <DuplicateIcon />
                {intl.formatMessage(
                    {
                        id: 'main.surveys.duplicate',
                        defaultMessage: 'Duplicate Survey',
                    })}
            </p>
            {surveyHasCampaign &&
            <p onClick={() => setShowRemoveFromCampaign()}>
                <UnlinkIcon/>
                {intl.formatMessage(
                    {
                        id: 'removeFromCampaign',
                        defaultMessage: 'Remove from campaign',
                    })}
            </p>
            }
            {surveyIsFinished ?
            <p onClick={() => {
                setShowArchivePopup()
            }}>
                <ArchiveIcon/>
                {intl.formatMessage(
                    {
                        id: 'survey.archive.header',
                        defaultMessage: 'Archive',
                    })}
            </p> :
                <p className={"disabled"} title={intl.formatMessage(
                    {
                        id: 'survey.archive.disabledTitle',
                        defaultMessage: 'Only finished surveys can be archived',
                    })}>
                    <ArchiveIcon/>
                    {intl.formatMessage(
                        {
                            id: 'survey.archive.header',
                            defaultMessage: 'Archive',
                        })}
                </p>
            }
            {surveyIsDraft &&
            <p className={"red"} onClick={()=>setShowDeletePopup()}>
                <DeleteIcon />
                {intl.formatMessage(
                    {
                        id: 'survey.delete.draft',
                        defaultMessage: 'Delete Draft',
                    })}
            </p>
            }
        </Popover>
        }
    </div>
}

function LoadingSkeleton() {
    const intl = useIntl()
    return <>
        <div className={"group-divider"}>
            <p>
                <span className={"chevron"}>
                    <Chevron />
                </span>
                {intl.formatMessage(
                    {
                        id: 'loading',
                        defaultMessage: 'Loading..',
                    })}
            </p>
        </div>
        <div className={"surveys-container"}>
            {
                [...Array(9)].map( (e, i) => {
                    return <div key={i} className={"survey skeleton-container"}>
                        <Skeleton height={20}/>
                        <Skeleton height={20} width={100}/>
                        <br /><br /><br /><br />
                        <Skeleton height={10}/>
                        <Skeleton height={10} width={100}/>
                        <br />
                        <Skeleton height={10} width={10} circle={true}/> <Skeleton height={10} width={50} inline={true}/>
                    </div>
                })
            }
        </div>
    </>
}